// Module
var code = "<script>let $editFormOrganism</script> <molecule-panel-error error-type=\"update\" error-box-type=\"fixed\"></molecule-panel-error> <molecule-form-edit> <organ-edit-panel-webspace-admin-options panel-right=\"$editFormOrganism.userPanelRight.admin\"></organ-edit-panel-webspace-admin-options> </molecule-form-edit> ";
// Exports
module.exports = code;